import { connect } from "react-redux";
import PropTypes from "prop-types";
import React from "react";
import flattenDeep from "lodash/flattenDeep";
import { DATETIME_FORMAT } from "config/constants";
import ComponentWithRevisions, {
  mapStateToProps,
  mapDispatchToProps,
} from "editor/utils/ComponentWithRevisions";

/**
 * displays who embargoed and/or scheduled the given content, and when
 * TODO: make this duality less confusing
 */
class Embargo extends ComponentWithRevisions {
  constructor(props) {
    super(props);
    this.getRevisionUser = this._getRevisionUser.bind(this);
  }

  render() {
    const {
      showScheduled,
      showDate,
      form: { scheduled_date: scheduled, embargo_until: embargo },
    } = this.props;
    if (!this.props.form) return null;
    let embargoText, embargoUserText, embargoDate;
    let scheduleText, scheduleUserText, scheduleDate;
    const embargoUser = this.getRevisionUser("Embargoed");
    const scheduleUser = this.getRevisionUser("Scheduled");
    if (embargo) {
      if (embargoUser) embargoUserText = ["by", embargoUser];
      embargoDate = ["until", showDate && embargo.format(DATETIME_FORMAT)];
      embargoText = ["embargoed", embargoUserText, embargoDate];
    }
    if (showScheduled && scheduled) {
      if ((!embargo || scheduleUser !== embargoUser) && scheduleUser)
        scheduleUserText = ["by", scheduleUser];
      if (!embargo || !scheduled.isSame(embargo, "minute"))
        scheduleDate = ["for", scheduled.format(DATETIME_FORMAT)];
      scheduleText = ["scheduled", scheduleUserText, scheduleDate];
    }
    const text = [
      "This",
      this.props.contentType,
      "was",
      scheduleText,
      embargoText && scheduleText && "and",
      embargoText,
    ];
    return (
      <span>
        {flattenDeep(text)
          .filter(t => t)
          .join(" ")}
      </span>
    );
  }

  /**
   * finds the user of the first matching revision
   * @param {string} comment
   */
  _getRevisionUser(comment) {
    const { revisions } = this.props;

    if (revisions && revisions.list) {
      const revision = revisions.list.find(
        rev => rev.user && rev.comment.includes(comment)
      );
      if (revision) {
        return revision.user.display_name;
      }
    }
  }
}

Embargo.propTypes = {
  ...ComponentWithRevisions.propTypes,
  showDate: PropTypes.bool.isRequired,
  showScheduled: PropTypes.bool.isRequired,
  contentType: PropTypes.string.isRequired,
};

Embargo.defaultProps = {
  showDate: true,
  showScheduled: false,
  contentType: "story",
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Embargo);
